import * as React from "react";
const SvgLoading = (props) => /* @__PURE__ */ React.createElement("svg", { className: "spinner", viewBox: "0 0 50 50", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { className: "path", cx: 25, cy: 25, r: 20, strokeWidth: 5 }));
export default SvgLoading;
